export { DefaultEffects } from '@fluentui/theme/lib/effects/DefaultEffects';
